import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface EditIconProps {
  filled?: boolean;
  color?: string;
  isHover?: boolean;
  hoverColor?: string;
  style?: React.CSSProperties;
}

export const EditIcon = ({
  filled = false,
  color = RoutalPalette.primary40,
  isHover = false,
  hoverColor = RoutalPalette.primary20,
  style,
}: EditIconProps) => {
  if (!filled) {
    return (
      <SvgIcon viewBox="0 0 20 20" fill="none" style={{ height: `20px`, ...style }}>
        <g id="Style=Outlined" clip-path="url(#clip0_122_632)">
          <path
            id="Vector"
            d="M9.0407 2.79932H2.67707C2.19486 2.79932 1.73239 2.99087 1.39142 3.33185C1.05044 3.67282 0.858887 4.13529 0.858887 4.6175V17.3448C0.858887 17.827 1.05044 18.2894 1.39142 18.6304C1.73239 18.9714 2.19486 19.163 2.67707 19.163H15.4043C15.8866 19.163 16.349 18.9714 16.69 18.6304C17.031 18.2894 17.2225 17.827 17.2225 17.3448V10.9811"
            fill="none"
            stroke={isHover ? hoverColor : color}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M15.8589 1.43569C16.2206 1.07403 16.7111 0.87085 17.2226 0.87085C17.734 0.87085 18.2245 1.07403 18.5862 1.43569C18.9479 1.79735 19.151 2.28786 19.151 2.79932C19.151 3.31079 18.9479 3.8013 18.5862 4.16296L9.94984 12.7993L6.31348 13.7084L7.22257 10.0721L15.8589 1.43569Z"
            fill="none"
            stroke={isHover ? hoverColor : color}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <line id="Line 4" x1="7.20853" y1="9.36971" x2="10.6599" y2="12.8211" stroke={isHover ? hoverColor : color} />
        </g>
        <defs>
          <clipPath id="clip0_122_632">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  }

  return (
    <SvgIcon viewBox="0 0 20 20" fill="none" style={{ height: `20px`, ...style }}>
      <g id="Style=flat" clip-path="url(#clip0_122_644)">
        <path
          id="Vector"
          d="M9.0407 2.79932H2.67707C2.19486 2.79932 1.73239 2.99087 1.39142 3.33185C1.05044 3.67282 0.858887 4.13529 0.858887 4.6175V17.3448C0.858887 17.827 1.05044 18.2894 1.39142 18.6304C1.73239 18.9714 2.19486 19.163 2.67707 19.163H15.4043C15.8866 19.163 16.349 18.9714 16.69 18.6304C17.031 18.2894 17.2225 17.827 17.2225 17.3448V10.9811"
          fill="none"
          stroke={isHover ? hoverColor : color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M15.8589 1.43569C16.2206 1.07403 16.7111 0.87085 17.2226 0.87085C17.734 0.87085 18.2245 1.07403 18.5862 1.43569C18.9479 1.79735 19.151 2.28786 19.151 2.79932C19.151 3.31079 18.9479 3.8013 18.5862 4.16296L9.94984 12.7993L6.31348 13.7084L7.22257 10.0721L15.8589 1.43569Z"
          fill={isHover ? hoverColor : color}
          stroke={isHover ? hoverColor : color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line id="Line 4" x1="7.20853" y1="9.36971" x2="10.6599" y2="12.8211" stroke="#FAFAFA" />
      </g>
      <defs>
        <clipPath id="clip0_122_644">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
